import React from "react";
import {Document, Page} from 'react-pdf/dist/esm/entry.webpack5';
import useResizeObserver from '@react-hook/resize-observer';
import {useRef, useState, useLayoutEffect} from 'react';
import {MdZoomIn} from "react-icons/md";


const useWidth = (target) => {
    const [width, setWidth] = useState(null);

    useLayoutEffect(() => {
        setWidth(target.current.getBoundingClientRect().width)
    }, [target]);

    useResizeObserver(target, (entry) => setWidth(entry.contentRect.width));
    return width;
};
export const PdfViewer = ({url, isZoom, onZoomPdf}) => {
    const wrapperDiv = useRef(null);
    const width = useWidth(wrapperDiv);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const onDocumentLoadSuccess = ({numPages}) => {
        setNumPages(numPages);
    }

    if (isZoom) {
        let pages = [];
        for (let i = 0; i < numPages; i++) {
            pages.push(<Page pageNumber={i + 1} width={width} key={i+1}/>);
        }

        return (
            <div ref={wrapperDiv} className='pdf-viewer-container'>
                <Document file={url} onLoadSuccess={onDocumentLoadSuccess} loading={"Loading..."}
                          renderMode="svg"
                          renderTextLayer={false}
                          renderAnnotationLayer={false}
                          className={'pdf'}
                >
                    {pages}
                </Document>
            </div>
        );
    }

    return (
        <div ref={wrapperDiv} className='pdf-viewer-container' onClick={() => onZoomPdf(url)}>
            <Document file={url} onLoadSuccess={onDocumentLoadSuccess} loading={"Loading..."}
                      renderMode="svg"
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                      className={'pdf'}
            >
                <Page pageNumber={1} width={width}/>
            </Document>
            <div className="middle">
                <div className="text"><MdZoomIn/></div>
            </div>
        </div>
    );
};
